import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang, CONTACT } from "../i18n";

// WhatsApp glyph
function WaIcon({ className }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.117.555 4.184 1.61 6.008L4 29l8.184-1.578a12 12 0 0 0 3.82.633h.004C22.625 28.055 28 22.672 28 16.05 28 9.43 22.625 3 16.004 3zm0 21.86h-.004a9.83 9.83 0 0 1-3.36-.61l-.24-.09-4.855.938.98-4.73-.156-.243a9.79 9.79 0 0 1-1.5-5.223c0-5.43 4.42-9.85 9.86-9.85 2.633 0 5.105 1.027 6.965 2.89a9.78 9.78 0 0 1 2.887 6.968c0 5.43-4.42 9.85-9.86 9.85zm5.406-7.38c-.297-.148-1.758-.867-2.03-.966-.273-.1-.47-.148-.668.15-.196.296-.766.965-.94 1.163-.172.198-.347.223-.644.075-.297-.15-1.254-.462-2.39-1.475-.883-.788-1.48-1.76-1.653-2.057-.173-.297-.018-.457.13-.605.134-.133.297-.347.446-.52.15-.174.198-.298.297-.497.099-.198.05-.372-.025-.52-.074-.15-.668-1.612-.916-2.207-.24-.578-.485-.5-.668-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.478 0 1.462 1.065 2.875 1.213 3.073.148.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.695.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const href = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t.whatsappLabel)}`;

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float-btn"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          className="fixed bottom-5 right-5 z-50 group flex items-center"
        >
          <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-2xl shadow-black/40">
            <span className="absolute inset-0 rounded-full bg-[#25D366] pulse-ring" />
            <WaIcon className="relative h-7 w-7" />
          </span>
          <span className="hidden md:block max-w-0 group-hover:max-w-xs overflow-hidden whitespace-nowrap transition-[max-width] duration-500">
            <span className="ml-3 bg-black/85 backdrop-blur border border-white/10 text-white text-sm font-medium px-4 py-2.5 rounded-full">
              {t.whatsappLabel}
            </span>
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
